<template>
    <div class="grid ls-choose-your-service__container">
        <div class="grid__col-12">
            <h2
                class="ls-align--center ls-condensed ls-margin--top section-title"
                :class="{ 'ls-margin--bottom': screenSize.xs }"
            >
                <span v-if="isLawnStarter">Schedule Your Lawn Service</span>
                <span v-else>Lawn service for {{ order.address.street }}</span>
            </h2>

            <p
                v-if="isLawnStarter"
                class="ls-align--center"
                data-font-size="-1"
                style="margin-top: 3px;"
            >
                <span
                    class="ls-bold"
                    :class="{
                        'ls-color--green--color-dodge': isLawnStarter,
                        'll-color-primary': isLawnLove,
                    }"
                    >{{ socialProof }} neighbors&nbsp;
                </span>
                <span>in {{ order.address.zip }} already use {{ brand }}. Join them today.</span>
            </p>
            <p v-else class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                <span class="ls-bold">{{ socialProof }} people near you&nbsp; </span>
                <span>already use {{ brand }}. Join them today.</span>
            </p>
            <hr />
        </div>

        <div class="grid__col-12">
            <h2 class="ls-condensed ls-margin--bottom section-title section-title--frequency">
                <a
                    v-if="!screenSize.xs"
                    v-ls-track.click="{
                        target: 'order-form--non-mowing',
                    }"
                    class="ls-normal ls-color--gray--mid ls-float-right"
                    data-font-size="-1"
                    @click.prevent="gotoNonMowing()"
                >
                    <span
                        v-if="
                            !isLawnLove ||
                            (isLawnLove && featureFlags.flags['lawnlove.customerLeads'])
                        "
                        class="non-mowing-link"
                        test-id="non-mowing-link"
                    >
                        I'm not looking for lawn mowing&nbsp;
                        <i class="fa fa-long-arrow-right"></i>
                    </span>
                </a>
                <span>
                    Choose your
                    <span class="ls-nowrap">mowing frequency</span>
                </span>
            </h2>
        </div>

        <ls-mowing-selection />

        <div v-if="screenSize.xs" class="grid__col-12 ls-align--center ls-margin--bottom">
            <a
                v-ls-track.click="{
                    target: 'order-form--non-mowing',
                }"
                class="ls-color--gray--mid"
                data-font-size="-1"
                @click.prevent="gotoNonMowing()"
            >
                <span
                    v-if="
                        !isLawnLove || (isLawnLove && featureFlags.flags['lawnlove.customerLeads'])
                    "
                >
                    I'm not looking for lawn mowing&nbsp;
                    <i class="fa fa-long-arrow-right"></i>
                </span>
            </a>
        </div>

        <div class="grid__col-sm-7 preferred-start-date">
            <ls-datepicker
                :options="options"
                :datepicker-date="order.start_date"
                :disabled-days="getDisabledDays()"
                @dateSelected="updateStartDate($event)"
            ></ls-datepicker>
        </div>

        <ls-view-other-services></ls-view-other-services>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import * as types from '@/store/types';
import lsMowingSelection from '@/components/original-mydot/mowing-selection/MowingSelection.vue';
import lsViewOtherServices from '@/components/original-mydot/view-other-services/ViewOtherServices.vue';
import lsDatepicker from '@/components/original-mydot/datepicker/Datepicker.vue';
import brandMixin from '@/mixins/brand.mixin';

export default {
    components: {
        lsMowingSelection,
        lsViewOtherServices,
        lsDatepicker,
    },
    mixins: [brandMixin],
    data() {
        return {};
    },
    computed: {
        ...mapState(['order', 'screenSize', 'featureFlags']),
        socialProof() {
            const lastDigitOfZip = parseInt(_.last(this.order.address.zip), 0);

            return lastDigitOfZip ? lastDigitOfZip + 40 : 40;
        },
        options() {
            return { minDate: _.get(this.order, 'earliest_start_date') };
        },
    },
    methods: {
        ...mapGetters({
            getDisabledDays: types.ORDER__GET_DISABLED_DAYS,
        }),
        ...mapActions({
            updateStartDate: types.ORDER__UPDATE_START_DATE,
        }),
        gotoNonMowing() {
            this.$router.push({ name: 'nonMowingForm' });
        },
    },
};
</script>

<style lang="scss" scoped>
.preferred-start-date {
    margin-left: 10px;
}

.themed-lawnlove {
    .section-title--frequency {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
    }

    .non-mowing-link {
        color: $theme-color-gray-dark;
    }
}
</style>
